export default function (conf, value) {
    const { __config__ } = conf
    const { defaultValue } = __config__
    let valueForMater
    if (Array.isArray(value)) {
        valueForMater = value
    } else if (value === null || value === undefined || value === '') {
        valueForMater = []
    } else {
        valueForMater = value.split(',')
    }
    return {
        attrs: {
            value: value || defaultValue || [],
        },
        on: {
            change: value => {
                this.$emit('input', value.join())
            }
        },
        props: {
            value: valueForMater
        }
    }
}